var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dl-page-header" },
    [
      _c("dl-breadcrumb", { attrs: { item: _vm.breadcrumbList } }),
      _vm.title ? _c("h1", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }